document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];
    let allSwiperHero =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    //js-swiper-hero
    document.querySelectorAll('.js-swiper-hero').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiperS = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwiperHero[i] = swiperS;

        if(document.querySelectorAll('.js-hero-outlet').length > 0){
            document.querySelectorAll('.js-hero-outlet').forEach((outlet,i) => {
                outlet.addEventListener('mouseenter', () => {
                    
                    if(swiperS.slides.length > document.querySelectorAll('.js-hero-outlet').length){
                        swiperS.slideTo(i + 1);
                    } else {
                        swiperS.slideTo(i);
                    }
                   
                    
                })
                outlet.addEventListener('mouseleave', () => {
                    swiperS.slideTo(0);
                })
            })
        }
    });

});